<template>
  <div class="search-box">
    <form @submit.prevent="goToSearchPage">
      <input
        v-model="searchQuery"
        type="text"
        class="search-input"
        :placeholder="placeholder"
        @blur="hideSuggestions"
        @input="debounceSearch"
      />

      <font-awesome-icon
        class="search-icon"
        icon="fas fa-search"
        @click="goToSearchPage"
      />

      <div class="search-result-wrapper">
        <ul
          v-if="searchQuery.trim() && showSuggestions"
          class="search-dropdown"
        >
          <li
            v-for="(product, b) in searchSuggestions"
            :key="`search-${b}`"
            @mousedown.prevent="selectResult(product)"
          >
            <img
              :src="getProductImage(product)"
              class="suggestion-product-image"
            />
            <span>{{ product.title }}</span>
          </li>
          <li
            v-if="!searchSuggestions.length"
            class="no-result"
          >
            No Products Found
          </li>
        </ul>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL, BASE_IMAGE_PREFIX, PLACEHOLDER_IMAGE } from "@/globals";

export default {
  name: "SearchBox",

  props: {
    limit: {
      type: Number,
      default: 3
    },
    placeholder: {
      type: String,
      default: "Search products..."
    }
  },

  data() {
    return {
      BASE_IMAGE_PREFIX,
      PLACEHOLDER_IMAGE,
      searchQuery: "",
      searchTimeout: null,
      searchSuggestions: [],
      showSuggestions: false
    };
  },

  methods: {
    goToSearchPage() {
      if (!this.searchQuery.trim()) return;

      this.$router.push(
        `/search?b=${encodeURIComponent(this.searchQuery)}`
      );

      this.showSuggestions = false;
    },

    async fetchSuggestions() {
      try {
        const response = await axios.get(`${BASE_URL}/api/products`, {
          params: {
            q: this.searchQuery?.trim(),
            limit: this.limit,
            hasActiveVariant: true,
          }
        });

        this.searchSuggestions = response.data.products;
        this.showSuggestions = true;
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    },

    debounceSearch() {
      clearTimeout(this.searchTimeout);

      if (!this.searchQuery.trim()) {
        this.searchSuggestions = [];
        return;
      }

      this.searchTimeout = setTimeout(() => {
        this.fetchSuggestions();
      }, 400);
    },

    selectResult(product) {
      this.$router.push(`/product/${product._id}`);
      this.showSuggestions = false;
    },

    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 150);
    },

    getProductImage(product) {
      return product.images?.length
        ? `${this.BASE_IMAGE_PREFIX}/${product.images[0]}`
        : this.PLACEHOLDER_IMAGE;
    }
  }
};
</script>

<style scoped lang="scss">
.search-box {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 50px;
  margin-right: 10px;

  .search-icon {
    position: absolute;
    top: 14px;
    right: 20px;
    font-size: 18px;
    cursor: pointer;
  }
}

.search-input {
  border-radius: 30px;
  padding: 12px 25px;
  border: none;
  width: 100%;
}

.search-result-wrapper {
  position: relative;

  .search-dropdown {
    position: absolute;
    width: 100%;
    background: white;
    border: 1px solid #ddd;
    border-radius: 10px;
    max-height: 220px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 5px 0 0 0;
    z-index: 10;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  li {
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  li:hover {
    background: #f5f5f5;
  }

  .suggestion-product-image {
    height: 40px;
    margin-right: 10px;
    border-radius: 4px;
  }
  .no-result {
    padding: 10px;
    color: #888;
    cursor: default;
    &:hover {
      background: white;
    }
  }
}
</style>